import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

export default class CommitmentText extends React.Component {
  renderAutoShipGreeting() {
    return (
      <div className="commitment-details__auto-ship-greeting text--large bold">
        Hello <span className="nowrap">Auto-Ship</span> Subscriber!
      </div>
    );
  }

  renderCheckoutDisclaimer() {
    const { commitmentMonths, maxQuantity, isSubscribed, name } = this.props;
    const MIN_PODS_PER_SUBSCRIPTION = window.gon.minimumSubscriptionItems || 2;

    return (
      <div className="commitment-details__checkout-disclaimer">
        {isSubscribed && this.renderAutoShipGreeting()}
        <br />
        <div className="text">
          <TranslatedMessage
            id={'cart.commitment_text.disclaimer'}
            values={{
              commitmentMonths,
              name,
              minimumPodsSubscription: MIN_PODS_PER_SUBSCRIPTION,
            }}
          />
          <br />
          <TranslatedMessage
            id={'cart.commitment_text.limit'}
            values={{ maxQuantity, name }}
          />
        </div>
      </div>
    );
  }

  renderSeeDetails() {
    const { commitmentMonths, maxQuantity, name } = this.props;
    const MIN_PODS_PER_SUBSCRIPTION = window.gon.minimumSubscriptionItems || 2;

    return (
      <div className="commitment-details__see-details text">
        <TranslatedMessage
          id={'cart.commitment_text.details'}
          values={{
            commitmentMonths,
            minimumPodsSubscription: MIN_PODS_PER_SUBSCRIPTION,
          }}
        />
        <br />
        <TranslatedMessage
          id={'cart.commitment_text.limit'}
          values={{ maxQuantity, name }}
        />
      </div>
    );
  }

  renderCancellationPolicy() {
    const { commitmentMonths, cancellationFee } = this.props;

    return (
      <div className="commitment-details__cancellation-policy text">
        <TranslatedMessage
          id={'cart.commitment_text.cancellation_policy'}
          values={{ cancellationFee, commitmentMonths }}
        />
        <a
          className="flat-blue nowrap"
          target="_blank"
          href="https://support.juulvapor.com/"
        >
          <TranslatedMessage
            id={'cart.commitment_text.customer_service_link'}
          />
        </a>.
      </div>
    );
  }

  renderModalContent() {
    const { addToCart } = this.props;

    return addToCart
      ? this.renderCheckoutDisclaimer()
      : this.renderSeeDetails();
  }

  render() {
    return (
      <div className="commitment-details">
        {this.renderModalContent()}
        <br />
        {this.renderCancellationPolicy()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CommitmentText.js